const icon = require('vue-svgicon');
icon.register({
    'home': {
        width: 18,
        height: 18,
        viewBox: '0 0 18 18',
        data: `<path pid="0" clip-rule="evenodd" d="M14 17v-7h3L9 1l-8 9h3v7h4v-3.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V17h4zM5 9H3l6-6.5L15 9h-2v7h-2v-3a1 1 0 00-1-1H8a1 1 0 00-1 1v3H5V9z"/>`,
    },
});
